<ll-toolnavbar>
    <asociacion-toolnavbar [displayButtons]="'new,search'" [queryParams]="{ 'mios': mios }"></asociacion-toolnavbar>
</ll-toolnavbar>
<ll-titulo>Asociaciones</ll-titulo>

<asociaciones [mios]="mios"></asociaciones>
